$(document).on('change', '[name="gift"]', function(){
  $('.gift_repeat').removeClass('active');
  $(this).parents('label').parents('.cv_img_gift_inner_main').parents('.cv_inner_gift_main').parents('.gift_repeat').addClass('active');
  var this_title = $(this).attr('data-title');
  $('.pro_sel_title').html(this_title);
  $('[name="gift"]').not(this).prop('checked', false).parents('label').parents('.cv_img_gift_inner_main').parents('.cv_inner_gift_main').parents('.gift_repeat').removeClass('active');
  if($(this).prop('checked') == false){
    $('.pro_sel_title').html(' ');
    $('.gift_repeat').removeClass('active');

  }
})


/* changes done 28 sep */

// $(document).on('mouseenter', '.single-option-selector', function(){
//   $(this)[0].size=$(this).find("option").length;
//   $(this).css('height', 'auto');
//   //console.log($(this)[0]);
// });

// $(document).on('mouseleave', '.single-option-selector', function(){ 
//   $(this)[0].size=0;   
// });

// $(document).on('click', '.single-option-selector', function(e){
//   e.preventDefault();
// });



// currency script

$(document).ready(function(){
	var pageType = typeof meta.page.pageType !== 'undefined' && meta.page.pageType !== "" ? meta.page.pageType : '';
  	var currencyDefaultToCheck = typeof defaultCurrency !== 'undefined' && defaultCurrency !== "" ? defaultCurrency : '';
  	if(pageType !== '' && pageType === 'home' && currencyDefaultToCheck !== "") {
  		$('.vela-currency__content').find('div[data-value="'+currencyDefaultToCheck+'"]').click();
    }
  
  setTimeout(function(){ 
    $('.velaFooterTitle').addClass('active');
    $('.velaContent').css('display', 'block');                     
  }, 3000);
});


$(document).on('click', '.pagination a', function(){
	var href = $(this).attr('href');
 	$('#loading').css('display', 'none');
	var baseUrl = $('link[rel="prefetch"]').attr('href');
  	location.href = baseUrl + href;
});

if (window.location.href.indexOf("challenge") > -1 || window.location.href.indexOf("wholesalers-contact-form") > -1 || window.location.href.indexOf("contact-us") > -1) {
      
} else {
  $(window).on('popstate', function(event) {
    location.reload();
  });	
}



$(document).ready(function(){
  
   $(window).scroll(function(){
     var windowScrollHeight = parseInt($(this).scrollTop());
      if(parseInt($('body').width()) < 992) {
            var velaTopHeight = parseInt($('#velaTopbar').height());
        if(windowScrollHeight >= (velaTopHeight + 20) ){
        	//console.log('windowScrollHeight', windowScrollHeight);
          	//console.log('velaTopHeight', velaTopHeight);
          
          $('.velaHeader').css({
            'position': 'fixed', 
            'top' : '0px', 
            'z-index' : '99' 
          });
          
          $('.mainContent').css({
            'position': 'relative',
    		'margin-top': '88px'
          });
          
        } else {
        	$('.velaHeader').css({
              'position': 'relative'
            });
          	$('.mainContent').css({
              'position': 'relative',
              'margin-top': '0px'
            });
        }
      }
   });
  
});

